import React, { useState, useEffect } from 'react';
import Button from '../common/Button';

const GuristaGanacsigadaTable = ({ items = [], onChange }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (items.length > 0) {
      setRows(
        items.map((item, index) => ({
          ...item,
          id: item.id ?? `row-${index}-${item.description || 'item'}`
        }))
      );
    } else {
      setRows([{ id: Date.now(), description: '', quantity: 0, notes: '' }]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pushChange = (newRows) => {
    onChange(
      newRows
        .filter((r) => r.description || r.quantity > 0 || r.notes)
        .map(({ id: _id, mukayfIc: _m, ...rest }) => rest)
    );
  };

  const addRow = () => {
    const newRows = [...rows, { id: Date.now(), description: '', quantity: 0, notes: '' }];
    setRows(newRows);
    pushChange(newRows);
  };

  const removeRow = (id) => {
    if (rows.length === 1) return;
    const newRows = rows.filter((row) => row.id !== id);
    setRows(newRows);
    pushChange(newRows);
  };

  const handleChange = (id, field, value) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return {
          ...row,
          [field]: field === 'quantity' ? parseInt(value, 10) || 0 : value
        };
      }
      return row;
    });
    setRows(newRows);
    pushChange(newRows);
  };

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto border border-gray-200 rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sharaxaadda Adeegga
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-24">
                Tirada
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Faah Faahin
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-16" />
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <input
                    type="text"
                    value={row.description}
                    onChange={(e) => handleChange(row.id, 'description', e.target.value)}
                    placeholder="Sharaxaadda adeegga..."
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                  />
                </td>
                <td className="px-4 py-3 text-center">
                  <input
                    type="number"
                    min="0"
                    value={row.quantity || ''}
                    onChange={(e) => handleChange(row.id, 'quantity', e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded text-center focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                  />
                </td>
                <td className="px-4 py-3">
                  <input
                    type="text"
                    value={row.notes}
                    onChange={(e) => handleChange(row.id, 'notes', e.target.value)}
                    placeholder="Fah Faahin..."
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
                  />
                </td>
                <td className="px-4 py-3 text-center">
                  {rows.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeRow(row.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Button
        type="button"
        variant="outline"
        onClick={addRow}
        icon={
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        }
      >
        Ku dar Saf Cusub
      </Button>
    </div>
  );
};

export default GuristaGanacsigadaTable;
